/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";

const PANEL_HEIGHT_KEY = "editor-panel-height";

export const usePanelHeight = (panelRef: React.RefObject<HTMLDivElement> | null) => {
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    const heightInitial = localStorage.getItem(PANEL_HEIGHT_KEY);

    // Set initial height
    if (heightInitial && panelRef?.current) {
      panelRef.current.style.height = `${heightInitial}px`;
    }
  }, []);

  const onPanelResizeStart = (e: React.MouseEvent) => {
    e.preventDefault();
    setDragging(true);
    document.body.style.userSelect = "none"; // Prevent text selection
  };

  const onPanelResize = (e: React.MouseEvent) => {
    e.preventDefault();

    if (dragging && panelRef?.current) {
      const newHeight = window.innerHeight - e.clientY;

      if (newHeight > 100 && newHeight < 500) {
        panelRef.current.style.height = `${newHeight}px`;

        localStorage.setItem(PANEL_HEIGHT_KEY, newHeight.toString());
      }
    }
  };

  const onPanelResizeEnd = () => {
    if (dragging) {
      setDragging(false);
      document.body.style.userSelect = "auto";
    }
  };

  return { onPanelResizeStart, onPanelResize, onPanelResizeEnd };
};
